/* Aura Noire · Crea tu pack en una sola página.
   Interfaz propia sobre el motor de EB Easy Bundle Builder (window.gbbSdk).
   El descuento y el carrito siguen siendo los reales de EB (Cart Transformation de Shopify).
   Toda la lógica que depende de los internos de EB vive en el bloque "MOTOR EB" (función loadEngine). */
(function () {
  'use strict';

  var root = document.querySelector('[data-an-pack]');
  if (!root) return;

  var cfgNode = root.querySelector('[data-an-config]');
  var cfg;
  try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }
  var T = cfg.texts || {};
  var BRANDS = {};
  var brandsReady = null;

  // handle → marca, leída de /collections/all?view=marcas (JSON paginado de 50 en 50; ver templates/collection.marcas.liquid).
  // Si falla o tarda, el configurador funciona igual, solo sin marca.
  function loadBrands() {
    if (brandsReady) return brandsReady;
    var root = cfg.root || '/';
    function page(n) {
      return fetch(root + 'collections/all?view=marcas&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          Object.keys(j.brands || {}).forEach(function (h) { BRANDS[h] = j.brands[h]; });
          return n < (j.pages || 1) && n < 10 ? page(n + 1) : null;
        });
    }
    brandsReady = Promise.race([
      page(1),
      new Promise(function (resolve) { setTimeout(resolve, 6000); })
    ]).catch(function (e) { if (window.console) console.warn('[Aura Noire] Marcas no disponibles:', e && e.message); });
    return brandsReady;
  }
  loadBrands();

  // Marca (metacampo custom.marca) y nombre a mostrar: si el título ya empieza o termina con la marca, se quita solo de la tarjeta.
  function displayName(title, brand) {
    if (!brand) return title;
    var t = String(title), b = String(brand);
    if (t.length - b.length - 1 > 3) {
      if (t.slice(-(b.length + 1)) === ' ' + b) return t.slice(0, -(b.length + 1));
      if (t.slice(0, b.length + 1) === b + ' ') return t.slice(b.length + 1);
    }
    return t;
  }
  T.remove = T.remove || 'Quitar';
  T.adding = T.adding || 'Añadiendo…';
  T.closeSummary = T.closeSummary || 'Ocultar';

  /* ======================================================================
     MOTOR EB  (única parte frágil: depende de los internos de la app EB)
     ----------------------------------------------------------------------
     loadEngine(pack) devuelve { inst, offerId, categoryId, stepId } o lanza EngineError.
     Pasos: 1) cargar el SDK con la función propia de EB, 2) leer la configuración del pack
     (que EB solo inyecta en la página de su producto), 3) crear el motor, 4) validarlo.
     Si algo cambia en EB, falla de forma controlada y la interfaz ofrece el pack nativo.
     ====================================================================== */
  function EngineError(code, message) {
    var e = new Error(message || code);
    e.code = code;
    return e;
  }

  var engineCache = {};

  function waitFor(test, timeoutMs, code) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      (function tick() {
        var value;
        try { value = test(); } catch (e) { value = null; }
        if (value) return resolve(value);
        if (Date.now() - started > timeoutMs) return reject(EngineError(code || 'TIMEOUT'));
        setTimeout(tick, 120);
      })();
    });
  }

  function extractBundleData(html) {
    // EB (desde la versión 1-487 de su extensión) entrega la configuración del pack en
    // <script type="application/json" data-gbb-bootstrap="bundles"> → activeBundleConfig.
    var boot = null;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('script[data-gbb-bootstrap="bundles"]');
      if (node) boot = JSON.parse(node.textContent);
    } catch (e) { boot = null; }
    if (boot && boot.activeBundleConfig && boot.activeBundleConfig.offerId) return boot.activeBundleConfig;

    // Formato anterior de EB: «let bundle_data = {...}» dentro de un <script>.
    var marker = 'let bundle_data = ';
    var start = html.indexOf(marker);
    if (start < 0) throw EngineError('NO_BUNDLE_DATA');
    var open = html.indexOf('{', start);
    var depth = 0, inString = false, escaped = false, i = open;
    for (; i < html.length; i++) {
      var ch = html.charAt(i);
      if (inString) {
        if (escaped) escaped = false;
        else if (ch === '\\') escaped = true;
        else if (ch === '"') inString = false;
      } else if (ch === '"') inString = true;
      else if (ch === '{') depth++;
      else if (ch === '}') { depth--; if (depth === 0) break; }
    }
    if (depth !== 0) throw EngineError('BUNDLE_DATA_UNBALANCED');
    return JSON.parse(html.slice(open, i + 1));
  }

  function validateEngine(inst, offerId) {
    var ok = inst && inst.f && inst.state && inst.category && inst.category.state && inst.step && inst.step.state && inst.discount && inst.discount.f;
    if (!ok) throw EngineError('ENGINE_SHAPE');
    ['addProductToBundle', 'clearCartItems', 'getCartItems', 'getCartData', 'addBundleToCart'].forEach(function (name) {
      if (typeof inst.f[name] !== 'function') throw EngineError('ENGINE_API_' + name);
    });
    if (typeof inst.discount.f.getDiscountMessage !== 'function') throw EngineError('ENGINE_API_message');
    if (!inst.state.productsDataMapByProductId || !inst.state.isBundleLoaded) throw EngineError('ENGINE_NOT_LOADED');
    var categoryId = Object.keys(inst.category.state.categoriesData || {})[0];
    var stepId = Object.keys(inst.step.state.stepsConfigData || {})[0];
    if (!categoryId || !stepId) throw EngineError('ENGINE_NO_CATEGORY');
    if (inst.bundleData && inst.bundleData.offerId !== offerId) throw EngineError('ENGINE_OFFER_MISMATCH');
    return { inst: inst, offerId: offerId, categoryId: categoryId, stepId: stepId };
  }

  function neutralizeEbRedirects() {
    // Evita que EB redirija tras añadir (desde /pages/... apuntaría a /pages/cart); la ruta del carrito la gestionamos nosotros.
    var app = window.gbbSdk && window.gbbSdk.settings && window.gbbSdk.settings.app;
    if (!app) return;
    app.redirectToCartEnabled = false;
    app.redirectToCheckoutEnabled = false;
    app.executeScriptAfterAddToCart = '';
    app.executeDefaultSideCartUpdate = false;

    // Tras añadir, EB llama a gbbExt.utility.handleSkaiLamaSideCartUpdate(), que abre la notificación nativa del tema
    // (cart-notification.renderContents → open). Aquí mostramos nuestra propia confirmación, así que, solo en esta página,
    // lo sustituimos por una versión que mantiene el aviso de EB y actualiza el contador sin abrir nada.
    var util = window.gbbExt && window.gbbExt.utility;
    if (util && !util.anPackPatched) {
      util.handleSkaiLamaSideCartUpdate = function () {
        try { document.dispatchEvent(new CustomEvent('gbbExt-side-cart-update')); } catch (e) {}
        refreshCartBadge();
        return Promise.resolve(true);
      };
      util.anPackPatched = true;
    }
  }

  async function loadEngine(pack) {
    var embed = await waitFor(function () {
      var e = window.gbbExtEmbed;
      return window.easybundles_ext_data && e && e.f && typeof e.f.importSDKAssets === 'function' ? e : null;
    }, 15000, 'EB_EMBED_MISSING');

    var links = window.easybundles_ext_data.bundleLinkData || [];
    var link = links.filter(function (b) {
      return b.offerHandle === pack.handle || (b.parentProductShopifyData && b.parentProductShopifyData.handle === pack.handle);
    })[0];
    if (!link || !link.offerId) throw EngineError('NO_OFFER_FOR_HANDLE');
    if (engineCache[link.offerId]) return engineCache[link.offerId];

    if (!window.gbbSdk) {
      await embed.f.importSDKAssets({ offerId: link.offerId, bundleDesignTemplate: link.bundleDesignTemplate });
    }
    await waitFor(function () {
      var s = window.gbbSdk;
      return s && typeof s.init === 'function' && typeof s.initialize === 'function' && s.events;
    }, 15000, 'SDK_NOT_LOADED');

    var response = await fetch(pack.url, { credentials: 'same-origin' });
    if (!response.ok) throw EngineError('PACK_PAGE_' + response.status);
    var bundleData = extractBundleData(await response.text());
    if (!bundleData || bundleData.offerId !== link.offerId || !bundleData.parentProductVariantId) throw EngineError('BUNDLE_DATA_INVALID');

    var inst;
    if (window.gbbSdk._initialized) {
      inst = await window.gbbSdk.initialize(bundleData);
    } else {
      var ext = window.easybundles_ext_data;
      window.easybundle_active_bundle_data = {
        _bundleData: bundleData,
        _preResolvedBundle: true,
        bundleType: 'SDK',
        bundleDesignTemplate: bundleData.bundleDesignTemplate,
        discountsData: {},
        languageData: ext.languageData,
        pageCustomizationData: ext.pageCustomizationData,
        userData: ext.userData
      };
      inst = await window.gbbSdk.init({ offerId: link.offerId });
    }
    neutralizeEbRedirects();
    var engine = validateEngine(inst, link.offerId);
    // EB trae los perfumes por páginas: se piden todas para mostrar la lista completa.
    try {
      if (inst.category.f && typeof inst.category.f.fetchAllProducts === 'function') {
        await inst.category.f.fetchAllProducts([engine.categoryId]);
      }
    } catch (e) { /* si falla, se usa lo ya cargado */ }
    engineCache[link.offerId] = engine;
    return engine;
  }
  /* ===================== FIN DEL MOTOR EB ===================== */

  /* ---------- Utilidades ---------- */
  var currencyCode = cfg.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currencyCode });
  function fmt(cents) { return money.format(Math.round(cents || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function sizeOf(variant) {
    var values = (variant.selectedOptions || []).map(function (o) { return o.value; }).concat([variant.title]);
    for (var i = 0; i < values.length; i++) {
      var m = /(\d+)\s*ml/i.exec(values[i] || '');
      if (m) return m[1];
    }
    return null;
  }
  function inStock(v) {
    if (v.availableForSale === false || v.available === false || v.currentlyNotInStock) return false;
    if (v.quantityAvailable != null && v.quantityAvailable <= 0) return false;
    return true;
  }
  function packFor(type, size) {
    for (var i = 0; i < cfg.packs.length; i++) {
      if (cfg.packs[i].type === type && cfg.packs[i].size === size && cfg.packs[i].handle) return cfg.packs[i];
    }
    return null;
  }
  function imageOf(p) {
    var img = p.featuredImage || (p.images && p.images[0]) || null;
    var src = img && (img.transformedSrc || img.originalSrc || img.url || img.src);
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  /* ---------- Referencias DOM ---------- */
  var els = {
    typeBtns: $$('[data-type]'),
    sizeBtns: $$('[data-size]'),
    builder: $('[data-builder]'),
    title: $('[data-builder-title]'),
    grid: $('[data-grid]'),
    state: $('[data-state]'),
    notice: $('[data-notice]'),
    search: $('[data-search]'),
    summary: $('[data-summary]'),
    count: $('[data-count]'),
    msg: $('[data-msg]'),
    meter: $('[data-meter]'),
    meterFill: $('[data-meter-fill]'),
    meta: $('[data-meta]'),
    list: $('[data-list]'),
    empty: $('[data-empty]'),
    retail: $('[data-retail]'),
    retailRow: $('[data-retail-row]'),
    saving: $('[data-saving]'),
    savingRow: $('[data-saving-row]'),
    total: $('[data-total]'),
    clear: $('[data-clear]'),
    add: $('[data-add]'),
    addLabel: $('[data-add-label]'),
    addPrice: $('[data-add-price]'),
    error: $('[data-error]'),
    toggle: $('[data-toggle]'),
    done: $('[data-done]'),
    doneMeta: $('[data-done-meta]'),
    viewCart: $('[data-view-cart]'),
    another: $('[data-another]'),
    progress: $$('[data-progress-step]'),
    sizeNote: $('[data-size-note]')
  };

  /* ---------- Estado ---------- */
  var sel = { type: null, size: null };
  var engine = null;
  var products = [];          // [{ id, title, image, variant, price, compare }]
  var productById = {};
  var loadSeq = 0;
  var queue = Promise.resolve();
  var adding = false;
  var clearArmed = null;

  function enqueue(job) {
    queue = queue.then(job, job);
    return queue;
  }

  function setProgress() {
    var states = { type: !!sel.type, size: !!(sel.type && sel.size) };
    els.progress.forEach(function (item) {
      var key = item.getAttribute('data-progress-step');
      var done = key === 'type' ? states.type : key === 'size' ? states.size : false;
      var active = key === 'type' ? !states.type : key === 'size' ? (states.type && !states.size) : states.size;
      item.classList.toggle('is-done', done);
      item.classList.toggle('is-active', active);
    });
  }

  function paintChoices() {
    els.typeBtns.forEach(function (b) {
      var on = b.getAttribute('data-type') === sel.type;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-selected', on);
    });
    els.sizeBtns.forEach(function (b) {
      var size = b.getAttribute('data-size');
      var on = size === sel.size;
      var available = !sel.type || !!packFor(sel.type, size);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-selected', on);
      b.disabled = !available;
    });
    setProgress();
  }

  function updateUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (sel.type) params.set('type', sel.type); else params.delete('type');
      if (sel.size) params.set('size', sel.size); else params.delete('size');
      history.replaceState(null, '', window.location.pathname + '?' + params.toString());
    } catch (e) {}
  }

  function showNotice(text) {
    if (!text) { els.notice.hidden = true; els.notice.textContent = ''; return; }
    els.notice.textContent = text;
    els.notice.hidden = false;
  }

  function showState(kind, extra) {
    // kind: loading | error | empty | null
    if (!kind) { els.state.hidden = true; els.state.innerHTML = ''; els.state.className = 'an-builder__state'; return; }
    els.state.hidden = false;
    els.state.className = 'an-builder__state an-builder__state--' + kind;
    if (kind === 'loading') {
      els.state.innerHTML = '<span class="an-pack__loader" aria-hidden="true"></span><p>' + esc(T.loading) + '</p>';
    } else if (kind === 'empty') {
      els.state.innerHTML = '<p>' + esc(T.emptyList) + '</p>';
    } else if (kind === 'error') {
      var pack = extra;
      els.state.innerHTML = '<p>' + esc(T.fallbackText) + '</p>' +
        (pack && pack.url ? '<a class="an-button an-button--outline" href="' + esc(pack.url) + '"><span>' + esc(T.fallbackButton) + '</span></a>' : '');
    }
  }

  /* ---------- Productos del formato elegido ---------- */
  function buildProducts(size) {
    var map = engine.inst.state.productsDataMapByProductId || {};
    var list = [];
    Object.keys(map).forEach(function (key) {
      var p = map[key];
      if (!p || !p.variants) return;
      var variant = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (sizeOf(p.variants[i]) === size && inStock(p.variants[i])) { variant = p.variants[i]; break; }
      }
      if (!variant) return;
      var price = Number(variant.price) || 0;
      var compare = variant.compareAtPrice && variant.compareAtPrice.amount ? Math.round(parseFloat(variant.compareAtPrice.amount) * 100) : 0;
      list.push({
        id: String(p.id || p.productId || key),
        numericId: String(p.productId || p.id || key).replace(/\D+/g, ''),
        title: p.title,
        brand: BRANDS[p.handle] || '',
        shown: displayName(p.title, BRANDS[p.handle] || ''),
        image: imageOf(p),
        variantId: variant.id,
        price: price,
        compare: compare > price ? compare : 0
      });
    });
    return list;
  }

  function cardHtml(p) {
    return '<li class="an-card" data-card data-vid="' + p.variantId + '" data-name="' + esc((p.brand + ' ' + p.title).toLowerCase()) + '">' +
      '<div class="an-card__media">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc((p.brand ? p.brand + ' ' : '') + p.shown) + '" loading="lazy" width="480" height="480">' : '') + '</div>' +
      (p.brand ? '<p class="an-card__brand">' + esc(p.brand) + '</p>' : '') +
      '<h3 class="an-card__name">' + esc(p.shown) + '</h3>' +
      '<p class="an-card__price"><span>' + fmt(p.price) + '</span>' + (p.compare ? '<s>' + fmt(p.compare) + '</s>' : '') + '</p>' +
      '<div class="an-card__action" data-action></div>' +
      '</li>';
  }

  function renderGrid() {
    els.grid.innerHTML = products.map(cardHtml).join('');
    if (!products.length) showState('empty'); else showState(null);
    applyFilter();
  }

  function applyFilter() {
    var q = (els.search.value || '').trim().toLowerCase();
    $$('[data-card]', els.grid).forEach(function (card) {
      card.hidden = q && card.getAttribute('data-name').indexOf(q) === -1;
    });
  }

  function actionHtml(qty, title) {
    if (!qty) {
      return '<button type="button" class="an-card__add" data-op="inc" aria-label="' + esc(T.add + ' ' + title) + '">' + esc(T.add) + '</button>';
    }
    return '<div class="an-stepper" role="group" aria-label="' + esc(title) + '">' +
      '<button type="button" data-op="dec" aria-label="' + esc(T.remove + ' ' + title) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '<span aria-live="polite">' + qty + '</span>' +
      '<button type="button" data-op="inc" aria-label="' + esc(T.add + ' ' + title) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M10 4v12" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '</div>';
  }

  /* ---------- Lectura del motor ---------- */
  function readItems() {
    var items = [];
    try { items = engine.inst.f.getCartItems() || []; } catch (e) {}
    return items.filter(function (i) { return i && i.quantity > 0; });
  }

  function countPerfumes(items) {
    return items.reduce(function (n, i) { return n + i.quantity; }, 0);
  }

  // Mensaje de descuento propio, solo como respaldo si el texto de EB llega con marcadores sin resolver.
  function composeMessage(n) {
    try {
      var rules = engine.inst.discount.state.discountConfiguration.rules || [];
      var rule = rules[0];
      if (!rule || rule.type !== 'quantity') return '';
      var buy = parseInt(rule.value, 10), gets = parseInt(rule.getsQuantity, 10) || 1, pct = parseFloat(rule.discountValue);
      var needed = buy + gets;
      var offer = pct >= 100 ? 'gratis' : 'con un ' + pct + ' % de descuento';
      if (n >= needed) return '¡Conseguido! ' + gets + ' ' + (gets === 1 ? 'perfume' : 'perfumes') + ' ' + offer + '.';
      var missing = needed - n;
      return 'Añade ' + missing + ' ' + (missing === 1 ? 'perfume más' : 'perfumes más') + ' para llevarte ' + gets + ' ' + offer + '.';
    } catch (e) { return ''; }
  }

  // Mensajes propios de la promo de cada tipo, traducidos desde los locales del tema (aura_pack.<tipo>_progress_*).
  // Árabes: elige 4 y el 5.º gratis. Diseñador: elige 2 y el 3.º al 50 %.
  // Solo se usan si la regla real cargada de EB coincide exactamente con la promo; si no, se mantiene el mensaje de EB.
  var PROMOS = {
    arabes: { texts: 'arabesProgress', buy: 4, get: 1, percent: 100 },
    disenador: { texts: 'disenadorProgress', buy: 2, get: 1, percent: 50 }
  };

  function promoMessage(n) {
    try {
      var promo = PROMOS[sel.type];
      var list = promo && T[promo.texts];
      if (!list || list.length < promo.buy + 2) return '';
      var rules = engine.inst.discount.state.discountConfiguration.rules || [];
      var rule = rules[0];
      if (rules.length !== 1 || !rule || rule.type !== 'quantity') return '';
      if (parseInt(rule.value, 10) !== promo.buy || (parseInt(rule.getsQuantity, 10) || 1) !== promo.get || parseFloat(rule.discountValue) !== promo.percent) return '';
      return list[Math.max(0, Math.min(list.length - 1, n))] || '';
    } catch (e) { return ''; }
  }

  function sync() {
    if (!engine) return;
    var items = readItems();
    var qtyByVariant = {};
    items.forEach(function (i) { qtyByVariant[String(i.id)] = i.quantity; });

    // Tarjetas
    $$('[data-card]', els.grid).forEach(function (card) {
      var vid = card.getAttribute('data-vid');
      var qty = qtyByVariant[vid] || 0;
      var title = card.querySelector('.an-card__name').textContent;
      card.classList.toggle('is-selected', qty > 0);
      var slot = card.querySelector('[data-action]');
      var key = qty ? 'on' + qty : 'off';
      if (slot.getAttribute('data-key') !== key) {
        slot.innerHTML = actionHtml(qty, title);
        slot.setAttribute('data-key', key);
      }
    });

    // Resumen
    var n = countPerfumes(items);
    var cd = null, breakdown = null, message = '', percent = 0;
    try { cd = engine.inst.f.getCartData(); } catch (e) {}
    try { breakdown = engine.inst.cart.f.getBundleBreakdown(); } catch (e) {}
    try { message = engine.inst.discount.f.getDiscountMessage() || ''; } catch (e) {}
    try { percent = Number(engine.inst.discountProgressBar.f.getBundleDiscountProgressPercent()) || 0; } catch (e) {}
    if (/[{}]/.test(message)) message = composeMessage(n); // el texto de EB trae un marcador roto: usamos uno propio

    var retail = cd ? cd.total_price || 0 : 0;
    var total = cd && cd.discounted_price != null ? cd.discounted_price : retail;
    if (breakdown && breakdown.products) {
      retail = breakdown.products.retailCents != null ? breakdown.products.retailCents : retail;
      total = breakdown.products.discountedCents != null ? breakdown.products.discountedCents : total;
    }
    var saving = Math.max(0, Math.round(retail) - Math.round(total));

    els.count.textContent = n + ' ' + (n === 1 ? T.perfumeOne : T.perfumeMany);
    els.msg.textContent = promoMessage(n) || (n ? message : T.pickHint);
    var pct = n ? Math.max(0, Math.min(100, percent)) : 0;
    els.meterFill.style.transform = 'scaleX(' + (pct / 100) + ')';
    els.meter.setAttribute('aria-valuenow', String(Math.round(pct)));
    els.meta.textContent = (sel.type ? $('[data-type="' + sel.type + '"]').getAttribute('data-label') : '') + (sel.size ? ' · ' + sel.size + ' ml' : '');

    els.list.innerHTML = items.map(function (i) {
      var p = productById[String(i.id)] || null;
      var title = p ? p.title : (i.product_title || i.title);
      var img = p && p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48" loading="lazy">' : '';
      return '<li class="an-line" data-line data-vid="' + i.id + '">' +
        '<span class="an-line__img">' + img + '</span>' +
        '<span class="an-line__name">' + esc(title) + '</span>' +
        '<span class="an-line__qty">× ' + i.quantity + '</span>' +
        '<button type="button" class="an-line__remove" data-op="remove-line" aria-label="' + esc(T.remove + ' ' + title) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.3" fill="none"/></svg></button>' +
        '</li>';
    }).join('');
    els.empty.hidden = n > 0;
    els.retail.textContent = fmt(retail);
    els.total.textContent = fmt(total);
    els.saving.textContent = '− ' + fmt(saving);
    els.retailRow.hidden = saving <= 0;
    els.savingRow.hidden = saving <= 0;
    els.clear.hidden = n === 0;
    els.addPrice.textContent = n ? fmt(total) : '';
    els.add.disabled = adding || n === 0;
    root.classList.toggle('has-items', n > 0);
  }

  /* ---------- Acciones sobre el motor ---------- */
  function setQuantity(variantId, quantity) {
    return enqueue(async function () {
      if (!engine) return;
      var result;
      try {
        result = await engine.inst.f.addProductToBundle({
          categoryId: engine.categoryId, variantId: variantId, quantity: quantity, stepId: engine.stepId, showToast: false
        });
      } catch (e) { result = { ok: false, data: { message: e.message } }; }
      if (result && result.ok === false && result.data && result.data.message) {
        els.error.textContent = result.data.message;
        els.error.hidden = false;
      } else {
        els.error.hidden = true;
      }
      sync();
    });
  }

  function clearEngine(eng) {
    return enqueue(async function () {
      try { await (eng || engine).inst.f.clearCartItems(); } catch (e) {}
    });
  }

  /* ---------- Cambiar de tipo / formato ---------- */
  async function applySelection(options) {
    options = options || {};
    var seq = ++loadSeq;
    var previous = engine;
    var snapshot = [];
    if (previous && options.keepItems) {
      snapshot = readItems().map(function (i) { return { productId: String(i.product_id), qty: i.quantity }; });
    }
    var hadItems = previous ? readItems().length > 0 : false;

    paintChoices();
    updateUrl();
    showNotice('');
    els.done.hidden = true;
    root.classList.remove('is-done');

    if (!sel.type || !sel.size) {
      els.builder.hidden = !(sel.type && sel.size);
      return;
    }
    var pack = packFor(sel.type, sel.size);
    if (!pack) { els.builder.hidden = true; return; }

    els.builder.hidden = false;
    els.grid.innerHTML = '';
    els.search.value = '';
    showState('loading');
    sync();

    if (previous) await clearEngine(previous);

    var eng;
    try {
      eng = await loadEngine(pack);
    } catch (e) {
      if (seq !== loadSeq) return;
      engine = null;
      products = [];
      productById = {};
      showState('error', pack);
      els.add.disabled = true;
      els.count.textContent = '0 ' + T.perfumeMany;
      els.msg.textContent = '';
      if (window.console) console.warn('[Aura Noire] No se pudo preparar el pack con EB:', e && (e.code || e.message));
      return;
    }
    if (seq !== loadSeq) return;

    engine = eng;
    await clearEngine(eng); // parte siempre de un pack vacío
    await loadBrands();
    products = buildProducts(sel.size);
    productById = {};
    products.forEach(function (p) { productById[String(p.variantId)] = p; });
    renderGrid();
    sync();

    if (snapshot.length) {
      var dropped = 0;
      for (var i = 0; i < snapshot.length; i++) {
        var match = products.filter(function (p) { return p.numericId === snapshot[i].productId.replace(/\D+/g, ''); })[0];
        if (match) { await setQuantity(match.variantId, snapshot[i].qty); } else { dropped += snapshot[i].qty; }
      }
      if (dropped) showNotice((T.sizeDropped || '').replace(/\{n\}/g, dropped));
    } else if (options.typeChanged && hadItems) {
      showNotice(T.typeReset);
    }
    if (options.focus) {
      var heading = els.title;
      if (heading) heading.focus({ preventScroll: true });
      var top = els.builder.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  /* ---------- Eventos ---------- */
  root.addEventListener('click', function (event) {
    var typeBtn = event.target.closest('[data-type]');
    if (typeBtn && root.contains(typeBtn)) {
      var nextType = typeBtn.getAttribute('data-type');
      if (nextType === sel.type) return;
      var changed = !!sel.type;
      sel.type = nextType;
      if (sel.size && !packFor(sel.type, sel.size)) sel.size = null;
      applySelection({ typeChanged: changed, focus: !!sel.size });
      return;
    }

    var sizeBtn = event.target.closest('[data-size]');
    if (sizeBtn && root.contains(sizeBtn) && !sizeBtn.disabled) {
      var nextSize = sizeBtn.getAttribute('data-size');
      if (nextSize === sel.size) return;
      var hadSize = !!sel.size;
      sel.size = nextSize;
      applySelection({ keepItems: hadSize, focus: !hadSize });
      return;
    }

    var op = event.target.closest('[data-op]');
    if (op && root.contains(op)) {
      var holder = op.closest('[data-vid]');
      if (!holder || !engine) return;
      var vid = holder.getAttribute('data-vid');
      var current = 0;
      readItems().forEach(function (i) { if (String(i.id) === vid) current = i.quantity; });
      var kind = op.getAttribute('data-op');
      if (kind === 'inc') setQuantity(Number(vid), current + 1);
      else if (kind === 'dec') setQuantity(Number(vid), Math.max(0, current - 1));
      else if (kind === 'remove-line') setQuantity(Number(vid), 0);
      return;
    }

    if (event.target.closest('[data-clear]')) {
      var button = els.clear;
      if (!clearArmed) {
        clearArmed = setTimeout(function () { clearArmed = null; button.textContent = button.getAttribute('data-label'); }, 3500);
        button.setAttribute('data-label', button.textContent);
        button.textContent = '¿Seguro? Pulsa otra vez';
        return;
      }
      clearTimeout(clearArmed); clearArmed = null;
      button.textContent = button.getAttribute('data-label');
      clearEngine().then(sync);
      return;
    }

    if (event.target.closest('[data-toggle]')) {
      var open = !els.summary.classList.contains('is-open');
      els.summary.classList.toggle('is-open', open);
      els.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      els.toggle.textContent = open ? T.closeSummary : T.openSummary;
      return;
    }

    if (event.target.closest('[data-add]')) { addToCart(); return; }

    if (event.target.closest('[data-another]')) {
      els.done.hidden = true;
      root.classList.remove('is-done');
      sync();
    }
  });

  els.search.addEventListener('input', applyFilter);

  /* ---------- Añadir al carrito ---------- */
  function refreshCartBadge() {
    return fetch((cfg.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        var bubble = link.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          link.appendChild(bubble);
        }
        var label = bubble.querySelector('span[aria-hidden]');
        if (label) label.textContent = cart.item_count < 100 ? cart.item_count : '';
      })
      .catch(function () {});
  }

  async function addToCart() {
    if (!engine || adding) return;
    adding = true;
    els.error.hidden = true;
    els.add.disabled = true;
    els.addLabel.textContent = T.adding;
    var metaText = els.meta.textContent;
    var result;
    await enqueue(async function () {
      try {
        neutralizeEbRedirects();
        result = await engine.inst.f.addBundleToCart({ showToast: false });
      } catch (e) {
        result = { ok: false, data: { message: e && e.message } };
      }
    });
    adding = false;
    els.addLabel.textContent = T.cartButton;
    if (result && result.ok) {
      els.doneMeta.textContent = metaText;
      els.done.hidden = false;
      root.classList.add('is-done');
      els.summary.classList.remove('is-open');
      els.toggle.setAttribute('aria-expanded', 'false');
      els.toggle.textContent = T.openSummary;
      refreshCartBadge();
    } else {
      var message = result && result.data && result.data.message;
      els.error.textContent = message || 'No hemos podido añadir el pack. Inténtalo de nuevo.';
      els.error.hidden = false;
    }
    sync();
  }

  /* ---------- Arranque ---------- */
  var params = new URLSearchParams(window.location.search);
  var initialType = params.get('type');
  var initialSize = params.get('size');
  if (initialType && els.typeBtns.some(function (b) { return b.getAttribute('data-type') === initialType; })) sel.type = initialType;
  if (sel.type && initialSize && packFor(sel.type, initialSize)) sel.size = initialSize;
  paintChoices();
  if (sel.type && sel.size) applySelection({});
})();
